import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/agent/payment/subscription' // 결제목록 조회

const fetchKey = () =>
	`${M_KEY}`;

export function useAgentPaymentSubList() {
	const { data: token } = useToken();

	const KEY = fetchKey();


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { agentPaymentSubList: data?.list, mutateAgentPaymentSubList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Agent Payment Sub List:', error);
		return { list: [], total: 0 };
	}
}